<template>
	<AppAutoSuggest
		:options="options"
		:active-item="activeItem"
		:auto-navigation="autoNavigation"
		:is-loading="isLoading"
		:placeholder="$t('autosuggests.contactcategories.placeholder')"
		@input="$emit('input', $event)"
		@load="loadOptions($event)"
	/>
</template>

<script lang="ts">
import { computed, defineComponent, type PropType, ref } from 'vue';
import type { SelectItem } from '@developers/scoro-ui';
import { AppAutoSuggest, AutoSuggestDefaultEmits } from '@/features/App';
import {
	useContactCategoryAutoSuggestLazyQuery,
	type ContactCategory,
	ContactCategoryAutoSuggestDocument,
} from '@/generated/graphql';

export default defineComponent({
	components: { AppAutoSuggest },

	props: {
		/**
		 * Selected dropdown item to display without fetching all list
		 */
		item: {
			type: Object as PropType<
				| (Partial<ContactCategory> &
						Pick<ContactCategory, 'id' | 'name'>)
				| undefined
			>,
			required: false,
			default: undefined,
		},

		autoNavigation: {
			type: Boolean,
			required: false,
			default: false,
		},
	},

	emits: AutoSuggestDefaultEmits,

	setup(props) {
		const {
			loading: isLoading,
			load,
			onResult,
		} = useContactCategoryAutoSuggestLazyQuery();

		const options = ref<SelectItem[]>([]);

		onResult((result) => {
			if (result.data?.ContactCategoriesList) {
				options.value =
					result.data.ContactCategoriesList.map((row) => {
						return {
							id: row.id,
							title: row.name,
						};
					}) || [];
			}
		});

		const activeItem = computed<SelectItem | undefined>(() => {
			return props.item
				? {
						id: props.item.id,
						title: props.item.name,
					}
				: undefined;
		});

		const loadOptions = async (name: string) => {
			load(ContactCategoryAutoSuggestDocument, {
				name,
			});
		};

		return {
			activeItem,
			options,
			isLoading,
			loadOptions,
		};
	},
});
</script>
